import { getCookie } from 'lib/utils/cookies';

const IS_BETA_TEST = Boolean(parseInt(getCookie('beta_test'))) || false;

export function isBetaTest() {
  return IS_BETA_TEST;
}
